import { fromJS } from 'immutable';
import combineReducers from '../../../utilities/combineReducers';
import actions from '../constants';
import entities from './entities';

const initialState = fromJS({});

const scoreReducers = combineReducers({
  entities
});

export default (state = initialState, action) => {
  const codingActionTypes = Object.values(actions).filter(
    x => !x.endsWith('_ERROR')
  );

  if (!codingActionTypes.includes(action.type)) {
    return state;
  }

  return state.update(action.payload.gameId, initialState, x =>
    scoreReducers(x, action)
  );
};



// WEBPACK FOOTER //
// ./src/modules/scores/reducers/index.js